import Anchor from "@/navbar/anchor"


export default class NavLink {

    #linkElem;
    #anchorElem;
    #anchor;
    #id;
    #isCurrent;

    constructor(
        linkElem,
        anchorElem,
        id,
        isCurrent=false,
    ) {
        this.#linkElem = linkElem;
        this.#anchorElem = anchorElem;
        this.#id = id
        this.#isCurrent = isCurrent;
    }

    // getters
    get linkElem() {
        return this.#linkElem
    }
    get anchor() {
        return this.#anchor
    }
    get id() {
        return this.#id
    }
    get isCurrent() {
        return this.#isCurrent
    }

    // public methods
    setCurrent(bool) {
        if (bool) this.#linkElem.classList.add("current")
        else this.#linkElem.classList.remove("current")
    }

    async scrollToAnchor() {
        return new Promise((resolve, reject)=>{
            const anchorId = this.#anchor.anchorElem.getAttribute('id')
            function smoothScrollEndHandler() {
                window.removeEventListener("smoothScrollEnd", smoothScrollEndHandler)
                resolve()
            }
            window.addEventListener("smoothScrollEnd", smoothScrollEndHandler)
            window.dispatchEvent(new CustomEvent("smoothScrollToSelector", { detail: {selector: `#${anchorId}`} }))
        })
    }

    init() {
        this.#anchor = new Anchor(this.#anchorElem)
    }
}

